import { render, staticRenderFns } from "./FeedBackEditor.vue?vue&type=template&id=94ab153c&scoped=true"
import script from "./FeedBackEditor.vue?vue&type=script&lang=js"
export * from "./FeedBackEditor.vue?vue&type=script&lang=js"
import style0 from "./FeedBackEditor.vue?vue&type=style&index=0&id=94ab153c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ab153c",
  null
  
)

export default component.exports